export default "__VITE_ASSET__at3eN0ey__"